import React, { useEffect, useState } from 'react';
import { api, endpoints } from '../../api';
import { FormBlock, GridItem, PagesContainerUI } from '../../styles/styled';
import { PovsResponseType } from '../NmsMembers/types';

export const NmsProfilePage = () => {
  const [currentNms, setCurrentNms] = useState<PovsResponseType>({});

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<PovsResponseType>(endpoints.getUserData());

        setCurrentNms(response.data);
      } catch (err) {}
    })();
  }, []);

  return (
    <PagesContainerUI>
      <br />
      <FormBlock white>
        <GridItem align="flex-start" justify="flex-start">
          <div className="layout-text">
            {currentNms.lastname} {currentNms.firstname} {currentNms.patronymic}
          </div>
          <div className="text">email: {currentNms.email}</div>
        </GridItem>
      </FormBlock>
    </PagesContainerUI>
  );
};
